export default __webpack_public_path__ + "static/strategy_analysis_img-583feb7ed2f219ae8928db398b620b5c.png";